import Observable from '../../../../decorators/Observable';
import StoreFieldInSession from '../../../../decorators/StoreFieldInSession';
import AbstractSessionModel from '../../../../models/AbstractSessionModel';
import ElementFactory from './ElementFactory';
import PreviewElement from './PreviewElement';

class UserPreviewDataModel extends AbstractSessionModel {
  @StoreFieldInSession({
    serialize: (items: any) => {
      let serializedItems = {};

      for (let key in items) {
        serializedItems[key] = items[key].map((element) => {
          return element.serialize();
        });
      }

      return serializedItems;
    },
    deserialize(items: any) {
      let deserializedItems = {};

      for (let key in items) {
        deserializedItems[key] = items[key].map((element) => {
          const parsedElement = JSON.parse(element);

          let templateElement = ElementFactory.instantiateElement(
            parsedElement.element
          );

          templateElement.deserialize(element);
          return templateElement;
        });
      }

      return deserializedItems;
    }
  })
  @Observable()
  pageElements: {
    [pageId: string]: PreviewElement[];
  } = {};

  @StoreFieldInSession({
    serialize: (item: any) => {
      return item.map((element) => {
        return element.serialize();
      });
    },
    deserialize(value: any) {
      return value.map((element) => {
        const parsedElement = JSON.parse(element);

        let templateElement = ElementFactory.instantiateElement(
          parsedElement.element
        );

        templateElement.deserialize(element);
        return templateElement;
      });
    }
  })
  @Observable()
  templateElements: PreviewElement[] = [];

  constructor() {
    super();
    super.initFields();
  }

  public addTemplateElement(element) {
    // find if the element exists in the template
    const elementIndex = this.templateElements.findIndex(
      (el) => el.getUniqueId() === element.uniqueId
    );

    const templateElement = ElementFactory.instantiateElement(element);

    // if the element exists, update it
    if (elementIndex !== -1) {
      this.templateElements[elementIndex] = templateElement;
      return;
    }

    // if the element does not exist, add it
    this.templateElements.push(templateElement);

    console.log('templateElements', this.templateElements);
  }

  public addPageElement(pageId, element) {
    if (!this.pageElements[pageId]) {
      this.pageElements[pageId] = [];
    }

    const uniqueId = element.uniqueId;

    // find if the element exists in the page
    const elementIndex = this.pageElements[pageId].findIndex(
      (el) => el.getUniqueId() === uniqueId
    );

    const pageElement = ElementFactory.instantiateElement(element);

    // if the element exists, update it
    if (elementIndex !== -1) {
      this.pageElements[pageId][elementIndex] = pageElement;
      return;
    }

    // if the element does not exist, add it
    this.pageElements[pageId].push(pageElement);

    console.log('pageElements', this.pageElements);
  }

  public getPageElements(pageId) {
    let pageElements = [];

    if (this.pageElements[pageId]) {
      pageElements = this.pageElements[pageId].map((element) => {
        return element.getElementDataForPreview();
      });
    }

    return pageElements;
  }

  public getTemplateElements() {
    return this.templateElements.map((element) => {
      return element.getElementDataForPreview();
    });
  }

  getSessionKey(): string {
    return 'UserPreviewDataModel';
  }
}

export default new UserPreviewDataModel();
